import Cookie from 'js-cookie'

let cookieUtil = {
  clear () {
    let allCookie = Cookie.get()
    for (let x in allCookie) {
      Cookie.remove(x)
      localStorage.clear()
    }
  }
}

export default cookieUtil



// WEBPACK FOOTER //
// ./src/utils/cookieUtil.js